import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ab11c1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sequence-list" }
const _hoisted_2 = { class: "sequence-list__number" }
const _hoisted_3 = { class: "sequence-list__text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SequenceList',
  props: {
    items: {}
  },
  setup(__props: any) {

/**
 * 順序付きリストを表示するコンポーネント
 * 各項目の前に黒丸内に白色の数字を表示します
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "sequence-list__item"
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(index + 1), 1),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.text), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})